<template>
  <div>
    <vxe-toolbar>
      <template #buttons>
        <el-row>
          <el-col :span="12">
            <el-col :span="21">
              <b-form-input
                size="sm"
                type="search"
                placeholder="Search here..."
                v-model="page.userGroupName"
                @keyup.enter="getData()"
              />
            </el-col>
            <el-col :span="2">
              <b-button size="sm" variant="primary" @click="getData()">
                <i class="fa fa-search"></i>
              </b-button>
            </el-col>
          </el-col>
          <el-col :span="6">
            <b-button
              variant="outline-success"
              size="sm"
              @click="openEdit({ type: 'add' })"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('btn_create_group') || '创建分组' }}
            </b-button>
          </el-col>
        </el-row>
      </template>
    </vxe-toolbar>
    <vxe-grid
      height="250"
      :data="tableData"
      :radio-config="{ highlight: true, reserve: true }"
      :columns="tableColumns"
      size="mini"
      resizable
      auto-resize
      border
      ref="xGrid"
      row-id="userGroupCode"
    >
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="openEdit({ type: 'edit', code: row.userGroupCode })"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.userGroupCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:userItem="{ row }">
        <div>
          <el-tag
            size="mini"
            class="mr-2"
            v-for="(item, i) in row.userList"
            :key="i"
            >{{ (item.userNameEn || '') + (item.userName || '') }}</el-tag
          >
        </div>
      </template>
    </vxe-grid>
    <pagination
      size="mini"
      align="left"
      slot="pager"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      @change="handlePaginationChange"
    />
    <el-dialog
      v-if="dialogOptions.visible"
      append-to-body
      :title="dialogOptions.title"
      :visible.sync="dialogOptions.visible"
      :close-on-click-modal="false"
      width="650px"
      :before-close="() => $refs.edit.cancel()"
    >
      <edit
        :disabled="dialogOptions.disabled"
        :code="dialogOptions.code"
        ref="edit"
        @close="closeEdit()"
        @reload="getData()"
      />
      <span slot="footer">
        <el-button size="small" @click="() => $refs.edit.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="() => $refs.edit.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './edit'
export default {
  data() {
    return {
      tableData: [],
      tableColumns: [
        {
          field: 'seq',
          width: 30,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('table_head_choose') || '选择',
          width: 80,
          align: 'center',
          fixed: 'left',
          type: 'radio',
        },
        {
          field: 'col-opt',
          title: this.$l('table_head_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          fixed: 'left',
          slots: {
            default: 'opt',
          },
        },
        {
          headerAlign: 'center',
          field: 'userGroupName',
          align: 'left',
          width: 160,
          title: this.$l('table_head_group_name') || '分组名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          headerAlign: 'center',
          align: 'left',
          width: 600,
          title: this.$l('table_head_member') || '分组成员',
          slots: {
            default: 'userItem',
          },
        },
      ],
      dialogOptions: {
        visible: false,
        title: '',
        code: '',
      },
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0,
        userGroupName: '',
      },
      backDialogVisible: false,
    }
  },
  components: { Edit },
  mounted() {
    this.getData()
  },
  methods: {
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.getData()
      })
    },
    getData() {
      this.$api.baseUserGroupListApi({ ...this.page }).then((res) => {
        this.tableData = res.body.data
        this.page.pageTotal = res.body.count
      })
    },
    openEdit({ type = '', code = '' }) {
      const types = {
        edit: this.$l('dialog_title_editGroup') || '编辑人员分组',
        add: this.$l('dialog_title_addGroup') || '添加人员分组',
      }
      this.dialogOptions = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
      }
    },
    closeEdit() {
      this.dialogOptions.visible = false
    },
    getTableRadioChecked() {
      return (
        this.$refs.xGrid.getRadioReserveRecord() ||
        this.$refs.xGrid.getRadioRecord()
      )
    },
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '确认要删除该记录吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.baseUserGroupDelApi({ userGroupCode: code }).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.getData()
        })
      })
    },
    cancel() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
